import { GetMsgResCode } from '@/utils/constants';
import { addServerErrorTip, addTip, addToLiveTip, addToLiveOrWebFormTip } from '@/utils/sessionUtils';
import { getTrans } from '@/utils/instantLoaded/tools';
import firstInitStore from '@/stores/firstInit';
import { handleTerminalConfict } from './handleTerminalConfict';
import { whiteListCodes } from './whitelist';
import { UseLiveChatSDKApp } from '@/config/core';

const ERROR_HANDLER = {
  // bad request
  [GetMsgResCode.BAD_REQ]: () => {
    addToLiveTip();
  },
  // 登录态失效
  // v1.1.2 noLogin 后理论上不会触发，跳转登录通过reply_type = 9标识
  [GetMsgResCode.ILLEGAL]: () => {
    // @MARK: lazyLoad: LOGIN_HANDLER
    import('@/utils/loginHandler').then(({ default: LOGIN_HANDLER }) => {
      LOGIN_HANDLER(() => {
        window.location.reload();
      });
    });
  },
  [GetMsgResCode.TOO_FREQUENT]: () => {
    addTip(getTrans('error_too_frequent'));
  },
  // 请求超时
  [GetMsgResCode.TIMEOUT_ERROR]: () => {
    UseLiveChatSDKApp.is() ? import('@/stores/init/index').then(({ default: initStore }) => {
      initStore.initLiveChatSdk();
    }) : addToLiveOrWebFormTip();
  },
  // 网络错误
  [GetMsgResCode.NETWORK_ERROR]: () => {
    UseLiveChatSDKApp.is() ? import('@/stores/init/index').then(({ default: initStore }) => {
      initStore.initLiveChatSdk();
    }) : addToLiveOrWebFormTip();
  },
  // server error
  [GetMsgResCode.SERVER_ERROR]: () => {
    UseLiveChatSDKApp.is() ? import('@/stores/init/index').then(({ default: initStore }) => {
      initStore.initLiveChatSdk();
    }) : addToLiveOrWebFormTip();
  },

  // seesion id 错误，过期
  [GetMsgResCode.SESSION_ID_WRONG]: () => {
    firstInitStore.FETCH_DATA();
    addTip(getTrans('error_session_outofdate'));
  },
  // seesion id 没填
  [GetMsgResCode.SESSION_ID_MISSING]: () => {
    firstInitStore.FETCH_DATA();
    addTip(getTrans('error_session_outofdate'));
  },

  // user not login
  [GetMsgResCode.NOT_LOGIN]: () => {
    // 做成功处理
    return Promise.resolve({});
  },

  // cancel order Failed
  [GetMsgResCode.CANCEL_ORDER_FAILED]: (response) => {
    return Promise.resolve({ ...response, hasFailed: true });
  },

  // ariticle has been deleted
  [GetMsgResCode.ARTICLE_IS_DELETED]: () => {
    return Promise.resolve({ hasDeleted: true });
  },

  // 多端冲突，展示提示弹窗
  [GetMsgResCode.MULTI_TERMINAL_CONFLICT]: () => {
    handleTerminalConfict();
  },

  // 直连LiveChat
  [GetMsgResCode.LIVE_CHAT]: () => {
    import('@/stores/init/index').then(({ default: initStore }) => {
      UseLiveChatSDKApp.isHitChatbotGray = false;
      initStore.initLiveChatSdk();
    });
  },
};

export default ERROR_HANDLER;

const whiteListErrorCodes = [GetMsgResCode.ILLEGAL, GetMsgResCode.NOT_LOGIN];
export function doWhiteListErrorHandle(errorCode, response) {
  if ([...whiteListErrorCodes, ...whiteListCodes].includes(errorCode)) {
    return ERROR_HANDLER[errorCode] && ERROR_HANDLER[errorCode](response);
  }
}
